import axios from "../utils/request";

//栏目列表
export const getCate = params => axios.post("/api/category/getCate", params);
//提交表单
export const putguest = params => axios.post("/api/guestbook/putguest", params);
//新闻列表
export const getArt = params => axios.post("/api/article/getArt", params);
//新闻详情
export const getArtDetail = params =>
  axios.post("/api/article/getArtDetail", params);
//案例列表
export const getCase = params => axios.post("/api/casely/getCase", params);
//案例详情
export const getCaseDetail = params =>
  axios.post("/api/casely/getCaseDetail", params);
//配置列表
export const getLists = params => axios.get("/api/system/getLists", params);

//获取所有资讯的最新资讯
export const getNewZixun = params =>
  axios.get("/api/article/getNewZixun", params);

// 行业资讯总页面
export const getZixunAll = params =>
  axios.get("/api/article/getZixunAll", params);

//2025.net总首页
export const getAllIndexArts = params =>
  axios.get("/api/article/getAllIndexArts", params);

//2025.net总首页视频
export const getAllIndexVideos = params =>
  axios.get("/api/video/getAllIndexVideos", params);

//视频专区
export const getVideoList = params =>
  axios.get("/api/video/getVideoList", params);
//视频专区分类列表
export const getVideoTypeList = params =>
  axios.post("/api/video/getVideoTypeList", params);
//视频详情
export const getVideoDetail = params =>
  axios.post("/api/video/getVideoDetail", params);
//视频详情指定分类
export const getVideoDlt = params =>
  axios.post("/api/video/getVideoDlt", params);
